import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { Box, styled, useTheme } from '@mui/material';
import { constant, flow } from 'fp-ts/function';
import { random } from 'fp-ts/Random';
import { useEffect, useRef, useState } from 'react';
import ReactConfetti from 'react-canvas-confetti';
import { fireCoin, fireConfetti } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledConfetti = styled(ReactConfetti)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 200px;\n"])));

var useAnimationFrame = function useAnimationFrame(confetti, theme, duration) {
  var requestRef = useRef(0);
  useEffect(function () {
    var fire = function fire() {
      var origin = {
        x: random(),
        y: random()
      };
      fireCoin(confetti, theme, origin);
      requestRef.current = requestAnimationFrame(fire);
    };

    fire();
    var coinsTimer = setTimeout(function () {
      return cancelAnimationFrame(requestRef.current);
    }, duration * 1000);
    return function () {
      clearTimeout(coinsTimer);
      cancelAnimationFrame(requestRef.current);
    };
  }, [confetti]);
};

var useConfetti = function useConfetti(confetti) {
  useEffect(function () {
    var confettiTimer = setTimeout(function () {
      return fireConfetti(confetti);
    }, 500);
    return function () {
      return clearTimeout(confettiTimer);
    };
  }, [confetti]);
};

export var CoinsConfetti = function CoinsConfetti(_ref) {
  var duration = _ref.duration;

  var _useState = useState(null),
      confetti = _useState[0],
      setConfetti = _useState[1];

  var theme = useTheme();
  useAnimationFrame(confetti, theme, duration);
  return /*#__PURE__*/_jsx(Box, {
    "data-testid": "coins",
    "data-element": "Box",
    "data-component": "CoinsConfetti",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(StyledConfetti, {
      refConfetti: flow(constant, setConfetti),
      "data-element": "StyledConfetti",
      "data-component": "CoinsConfetti",
      "data-source-file": "index.tsx"
    })
  });
};
export var Confetti = function Confetti() {
  var _useState2 = useState(null),
      confetti = _useState2[0],
      setConfetti = _useState2[1];

  useConfetti(confetti);
  return /*#__PURE__*/_jsx(Box, {
    "data-testid": "confetti",
    "data-element": "Box",
    "data-component": "Confetti",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(StyledConfetti, {
      refConfetti: flow(constant, setConfetti),
      "data-element": "StyledConfetti",
      "data-component": "Confetti",
      "data-source-file": "index.tsx"
    })
  });
};